import qs from 'qs'

export function filtersFromPath(queryString) {
	const parsedPath = qs.parse(queryString)
	let filters = Object.create(null)

	Object.keys(parsedPath).forEach( k => {
		if (k === 'apr_type') {
			filters[k] = parsedPath[k]
		} else {
			filters[k] = parseInt(parsedPath[k],10)
		}
	})

	return filters
}


export function pathFromfilters(baseUrl, filters) {
	const search = document.location.search
	const queryString = qs.stringify(filters)

	return `${baseUrl}${search}#/${queryString}`
}



// WEBPACK FOOTER //
// ./js/website/utils/CategoryFilterRouting.js